import { canUseDOM } from '@ps/web-core-utils';

export const initModuleNativeClient = (module: string) => {
  // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
  if (canUseDOM && !window.starsweb?.[module] && window.starsweb?.module) {
    window.starsweb.module(module);
  }
};
